import type { AllRouteEndpoints } from "../routeTypes";
export const appSettingsAppGroupIdMessagePrioritizationCategoryCategoryIdCacheKeys: AllRouteEndpoints[] = [
  "/app_settings/:app_group_id/message_prioritization/categories_data",
];
